export default "__VITE_ASSET__XIStuybR__"